import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { IoCheckmarkCircle } from "react-icons/io5";
import { resetQuoteRequestPage } from "../../../store";

const Confirmation = ({ progress, lotteryResult }) => {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   setTimeout(() => {
  //     dispatch(resetQuoteRequestPage(0))
  //   }, 8000)
  // }, [])

  return (
    <div className="px-8 xl:px-16">

      <div className='mt-5 flex flex-col justify-center items-center'>
        <IoCheckmarkCircle className='h-[124px] w-[124px] text-[#60C5C5] mt-14 mb-10' />
        <p className='text-[var(--color-primary-purple)] font-bold text-3xl'>
          <b>Submitted!</b>
		</p>
		
		{(lotteryResult !== '' && window.location.pathname.includes('raffle')) &&
			<div className="mt-8">
				<p className="font-bold text-xl  text-center"><span className="text-2xl text-red-600">CONGRATULATIONS!</span><br/> You won a <b>{lotteryResult}</b> in the lottery.</p>
			</div>
		}
		
        <p className='mt-12 text-[var(--color-primary-purple)] font-semibold text-lg'>
          Thank you. You can close this tab.
        </p>

      </div>
    </div>
  );
};

export default Confirmation;